import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'web-design-system-notification',
  imports: [IconComponent],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent implements OnInit {
  @Input() public color: NotificationColor = 'default';
  @Input() public size: NotificationSize = 'mid';
  @Input() public isDismissible = false;
  @Input() public headline: string;
  @Input() public cacheIdentifier: string;

  @Output() public readonly dismissClicked = new EventEmitter<void>();

  public isDismissed = false;
  public readonly cacheKey = 'dismissed-notifications';

  ngOnInit(): void {
    this.isDismissed = this.#getDismissedNotifications().includes(this.cacheIdentifier);
  }

  public dismiss(): void {
    this.isDismissed = true;
    localStorage.setItem(this.cacheKey, JSON.stringify([...this.#getDismissedNotifications(), this.cacheIdentifier]));
    this.dismissClicked.emit();
  }

  #getDismissedNotifications(): string[] {
    return JSON.parse(localStorage.getItem(this.cacheKey)) || [];
  }
}

export type NotificationColor = 'green' | 'red' | 'default' | 'blue' | 'purple';
export type NotificationSize = 'small' | 'mid' | 'huge';
